import axios from 'axios';
import chromaniansImg from './images/races/Chromanians.png';
import duniansImg from './images/races/Dunians.png';
import sereniansImg from './images/races/Serenians.png';
import stellariansImg from './images/races/Stellarians.png';

import chromaniansBlurredImg from './images/blurred-races/Chromanians.png';
import duniansBlurredImg from './images/blurred-races/Dunians.png';
import sereniansBlurredImg from './images/blurred-races/Serenians.png';
import stellariansBlurredImg from './images/blurred-races/Stellarians.png';

import chromanianClotheImg from './images/chromanian-clothe.png';
import duneClotheImg from './images/dune-clothe.png';
import serenianClotheImg from './images/serenian-clothe.png';
import stellarClotheImg from './images/stellar-clothe.png';

export const LinkedInApi = {
  scope: 'r_liteprofile+r_emailaddress',
  clientId: process.env.REACT_APP_CLIENT_ID || '',
  redirectUrl: `${window.location.origin}/linkedin`,
};

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalConfig = error.config;
    const isUnauthorized =
      error.response?.status === 401 || error.response.status === 403;
    if (
      error.response.data?.path === NodeServer.refreshTokens &&
      isUnauthorized
    ) {
      localStorage.setItem('userName', '');
      window.location.href = '/sign-in';
    } else if (isUnauthorized && !originalConfig._retry) {
      originalConfig._retry = true;
      const refreshTokensUrl = `${NodeServer.baseURL}${NodeServer.refreshTokens}`;
      return axios
        .get(refreshTokensUrl, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.status === 200) {
            return axios.request(error.config);
          }
        });
    }
    return error;
  }
);

export const NodeServer = {
  baseURL: process.env.REACT_APP_BASE_URL,
  userProfile: '/users/profile',
  nftDetails: '/metadata/nft/',
  nftGallery: '/metadata/images/',
  teamGallery: '/metadata/team/',
  linkedinLogin: '/users/LinkedInLogIn',
  logOut: '/users/logOut',
  mint: '/nfts/mint',
  editProfile: '/users/profile',
  refreshTokens: '/users/refresh',
};

export const GoerliLink = 'https://goerli.etherscan.io';
export const ProdApiLink = 'https://fortuneteller.softserveinc.com/api';

export const HubSpotLink =
  'https://api.hsforms.com/submissions/v3/integration/submit/2744722/2b5f8bf4-05ea-4635-aff7-266a440bd94a';

export enum Race {
  Chromanians = 'chromanians',
  Dunians = 'dunians',
  Serenians = 'serenians',
  Stellarians = 'stellarians',
}

export const galleryRaceToImgMap = {
  [Race.Dunians]: duniansImg,
  [Race.Chromanians]: chromaniansImg,
  [Race.Serenians]: sereniansImg,
  [Race.Stellarians]: stellariansImg,
};

export const avatarRaceToImgMap = {
  [Race.Dunians]: duniansBlurredImg,
  [Race.Chromanians]: chromaniansBlurredImg,
  [Race.Serenians]: sereniansBlurredImg,
  [Race.Stellarians]: stellariansBlurredImg,
};

export const avatarRaceToClotheMap = {
  [Race.Dunians]: duneClotheImg,
  [Race.Chromanians]: chromanianClotheImg,
  [Race.Serenians]: serenianClotheImg,
  [Race.Stellarians]: stellarClotheImg,
};

export const avatarBackgroundArr = [
  {
    background:
      'linear-gradient(121deg, #AD00FF 0%, #0C0056 100%), linear-gradient(121deg, #FA00FF 0%, rgba(0, 255, 71, 0) 100%), linear-gradient(127deg, #00F0FF 0%, #A80000 100%), radial-gradient(107% 142% at 15% 104%, #F3D0FC 0%, #1700A4 100%), radial-gradient(100% 100% at 50% 0%, #7300A9 0%, #00FFE0 100%), radial-gradient(100% 100% at 50% 0%, #7300A9 0%, #00FFE0 100%), linear-gradient(127deg, #B7D500 0%, #2200AA 100%)',
    backgroundBlendMode:
      'overlay, color, overlay, difference, color-dodge, difference, normal',
  },
  {
    background:
      'linear-gradient(301.28deg, #FF0000 0%, #1D0027 100%), linear-gradient(121.28deg, #207A00 0%, #950000 100%), linear-gradient(238.72deg, #FFB800 0%, #000000 100%), linear-gradient(238.72deg, #00D1FF 0%, #A80000 100%), linear-gradient(125.95deg, #00E0FF 10.95%, #87009D 100%), linear-gradient(263.7deg, #B60000 3.43%, #B100A0 96.57%), linear-gradient(320.54deg, #800000 0%, #00C2FF 72.37%), linear-gradient(130.22deg, #8FA600 18.02%, #5A31FF 100%)',
    backgroundBlendMode:
      'difference, color-dodge, difference, lighten, color-dodge, difference, difference, normal',
  },
  {
    background:
      'linear-gradient(58.72deg, #000000 0%, #020063 100%), linear-gradient(360deg, #FF004D 0%, #D459FF 100%), radial-gradient(62.17% 100% at 50% 100%, #FF00F5 0%, #00FF75 100%), radial-gradient(50% 69.28% at 50% 50%, #AAD500 0%, #49006B 100%), radial-gradient(100% 148.07% at 0% 0%, #D50000 0%, #00FFFF 100%)',
    backgroundBlendMode: 'screen, color-burn, difference, difference, normal',
  },
  {
    background:
      'linear-gradient(50.22deg, #0066FF 0%, #FFAA7A 51.63%), linear-gradient(238.72deg, #FF0000 0%, #000000 100%), linear-gradient(301.28deg, #FF0000 0%, #735A00 100%), linear-gradient(121.28deg, #207A00 0%, #950000 100%), linear-gradient(238.72deg, #FFB800 0%, #000000 100%), linear-gradient(238.72deg, #00D1FF 0%, #00FF38 100%), linear-gradient(58.72deg, #B80000 0%, #1B00C2 100%), linear-gradient(125.95deg, #00E0FF 10.95%, #87009D 100%), linear-gradient(263.7deg, #B60000 3.43%, #B100A0 96.57%), linear-gradient(130.22deg, #DBFF00 18.02%, #3300FF 100%)',
    backgroundBlendMode:
      'multiply, color-dodge, difference, color-dodge, difference, lighten, difference, color-dodge, difference, normal',
  },
  {
    background:
      'linear-gradient(120deg, #FF0000 0%, #2400FF 100%), linear-gradient(120deg, #FA00FF 0%, #208200 100%), linear-gradient(130deg, #00F0FF 0%, #000000 100%), radial-gradient(110% 140% at 15% 90%, #ffffff 0%, #1700A4 100%), radial-gradient(100% 100% at 50% 0%, #AD00FF 0%, #00FFE0 100%), radial-gradient(100% 100% at 50% 0%, #00FFE0 0%, #7300A9 80%), linear-gradient(30deg, #7ca304 0%, #2200AA 100%)',
    backgroundBlendMode:
      'overlay, color, overlay, difference, color-dodge, difference, normal',
  },
  {
    background:
      'linear-gradient(301.28deg, #FF0000 0%, #1D0027 100%), linear-gradient(121.28deg, #207A00 0%, #950000 100%), linear-gradient(238.72deg, #FFB800 0%, #000000 100%), linear-gradient(238.72deg, #00D1FF 0%, #A80000 100%), linear-gradient(125.95deg, #00E0FF 10.95%, #87009D 100%), linear-gradient(263.7deg, #B60000 3.43%, #B100A0 96.57%), linear-gradient(320.54deg, #800000 0%, #00C2FF 72.37%), linear-gradient(130.22deg, #8FA600 18.02%, #5A31FF 100%)',
    backgroundBlendMode:
      'difference, color-dodge, difference, lighten, color-dodge, difference, difference, normal',
  },
  {
    background:
      'linear-gradient(121.28deg, #010012 0%, #00FF94 100%), linear-gradient(180deg, #00647A 0%, #FFFFFF 100%), linear-gradient(244.35deg, #FFB26A 0%, #C15151 50.58%, #00A3FF 100%), linear-gradient(244.35deg, #E03F3F 0%, #00114B 49.48%, #FF0000 100%), radial-gradient(100% 233.99% at 0% 100%, #FF0000 0%, #AD00FF 100%), linear-gradient(307.27deg, #096F5C 0.37%, #687EB5 50.19%, #8877CE 100%), radial-gradient(100% 140% at 100% 0%, #FF00C7 0%, #006C7A 49.48%, #FF9900 100%)',
    backgroundBlendMode:
      'overlay, difference, overlay, overlay, difference, color-dodge, normal',
  },
  {
    background:
      'linear-gradient(121.28deg, #010012 0%, #00FF94 100%), linear-gradient(180deg, #00647A 0%, #FFFFFF 100%), linear-gradient(244.35deg, #FFB26A 0%, #C15151 50.58%, #00A3FF 100%), linear-gradient(244.35deg, #E03F3F 0%, #00114B 49.48%, #FF0000 100%), radial-gradient(100% 233.99% at 0% 100%, #FF0000 0%, #AD00FF 100%), linear-gradient(307.27deg, #096F5C 0.37%, #687EB5 50.19%, #8877CE 100%), radial-gradient(100% 140% at 100% 0%, #FF00C7 0%, #006C7A 49.48%, #FF9900 100%)',
    backgroundBlendMode:
      'overlay, difference, overlay, overlay, difference, color-dodge, normal',
  },
  {
    background:
      'linear-gradient(180deg, #A90051 0%, #1E0031 100%), linear-gradient(121.28deg, #340067 0%, #000000 38.54%), linear-gradient(180deg, #00FF19 0%, #000000 100%), linear-gradient(294.84deg, #FF0000 0%, #450000 100%), linear-gradient(121.28deg, #32003A 0%, #FF4040 100%), radial-gradient(50% 72.12% at 50% 50%, #EB00FF 0%, #110055 100%)',
    backgroundBlendMode:
      'color-dodge, screen, overlay, exclusion, difference, normal',
  },
  {
    background:
      'linear-gradient(121.28deg, #0E5432 0%, #D6AD96 100%), linear-gradient(121.28deg, #FF0000 0%, #FFBABA 100%), linear-gradient(140.54deg, #7000FF 0%, #0015D1 72.37%), linear-gradient(307.43deg, #FFE927 0%, #00114D 100%), radial-gradient(107% 142.8% at 15.71% 104.5%, #FFFFFF 0%, #A7AA00 100%), #FFFFFF',
    backgroundBlendMode:
      'overlay, overlay, difference, difference, difference, normal',
  },
];

export const getRandomNumber = (maxNum: number) => {
  return Math.floor(Math.random() * maxNum);
};

export const TeamCollectionName = 'SoftServe Creative Team';
